import React from "react";
import "./Infographic.scss";
import { Container } from "react-bootstrap";
import info from "../../../assets/info.svg";

const Infographics = () => (
  <Container>
    <div className="info">
      <img className="info-pix" src={info} alt="infographics" />
    </div>
  </Container>
);

export default Infographics;
